export default "/list/static/images/help-icon-dark.svg";